<script>
    import Common from "../common/index";

    export default {
        name: "wenzi",
        mixins: [Common],
        data(){
            return {
                type: 'word',
                config: [
                    {
                        type: 'WordSelect',
                        value: ''
                    },
                    // {
                    //     type: 'SearchBox',
                    //     value: ''
                    // },
                    // {
                    //     type: 'TypeList',
                    //     form: [
                    //         {
                    //             title: '文字效果1',
                    //             data: [
                    //                 {url: this.$images.contents.datu, love: false},
                    //                 {url: this.$images.contents.datu, love: true},
                    //                 {url: this.$images.contents.datu, love: false},
                    //                 {url: this.$images.contents.datu, love: false},
                    //                 {url: this.$images.contents.datu, love: false},
                    //                 {url: this.$images.contents.datu, love: false},
                    //             ],
                    //             column: 2,
                    //         },
                    //         {
                    //             title: '文字效果2',
                    //             data: [
                    //                 {url: this.$images.contents.datu, love: false},
                    //                 {url: this.$images.contents.datu, love: true},
                    //                 {url: this.$images.contents.datu, love: false},
                    //                 {url: this.$images.contents.datu, love: false},
                    //                 {url: this.$images.contents.datu, love: false},
                    //                 {url: this.$images.contents.datu, love: false},
                    //             ],
                    //             column: 2,
                    //         },
                    //     ],
                    //     selected: [0]
                    // },
                    // {
                    //     type: 'MoreBtn',
                    //     value: ''
                    // },
                ]
            }
        },
    }
</script>
